import React from 'react';
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from 'react-compare-slider';

function CompareSlider({ img1, img2, title, desc }) {
  return (
    <div className="border border-grey rounded w-1/2">
      <div
        className="mx-auto"
        style={{
          width: 'auto',
          height: 'auto',
        }}>
        <ReactCompareSlider
          itemOne={
            <ReactCompareSliderImage src={img1} srcSet={img1} alt="Image one" />
          }
          itemTwo={
            <ReactCompareSliderImage src={img2} srcSet={img2} alt="Image two" />
          }
        />
      </div>
      <div className="flex flex-col my-2 justify-center">
        <div className="mx-auto">{title}</div>
        <div className="mx-auto ">{desc}</div>
      </div>
    </div>
  );
}

export default CompareSlider;
